/**
 * VERSIONE LIBRERIA 3
 *
 * UPLOAD SEMPLICE DA RIVEDERE
 */
var RenderUpload = Render.extend({
    type : 'upload',
    classData : 'upload',
    classTemplate : 'upload',
    itemViewTemplate : null,  // template del singolo item di view
    itemEditTemplate : null,  // template del singolo item di edit
    langs : ['it'],
    limit : null,
    modelName : null,
    icons : {".jpg" : "fa fa-picture-o"},
    icon_selector : "[data-icon_img]",
    uploaded_json : {},
    path_key : null,
    uploadType : 'foto',
    buttonLabel : 'upload',
    imagecacheTemplate : 'icon',

    init: function (key,config) {
        this._super(key,config);
        this.itemViewTemplate = '#' + this.prefixTemplateClass + '_' + this.uploadType + '_view_item_tpl';
        this.itemEditTemplate = '#' + this.prefixTemplateClass + '_' + this.uploadType + '_edit_item_tpl';
    },

    _renderEdit : function (jQe) {
        var self = this;
        self._renderTemplateData(jQe);
        jQe.find(self.control_selector).val(self.value).attr('name',self.key);
    },
    _finalizeEdit : function() {
        var self = this;
        $(self.container).find('[data-button_upload]').html(self.buttonLabel);
        $(self.container).find('[data-button_upload]').click(function () {
            self.upload();
        });
    },
    _renderView : function(jQe) {
        var self = this;
        //log.info("Render uppload view ", self.data);
        if (self.value) {

            if (self.uploadType == 'foto') {
                jQe.find('[data-render_element]').html('<img src="/viewimage/' + self.value + '/imagecache/' + self.imagecacheTemplate + '" />');
            } else {
                jQe.find('[data-render_element]').html('<a target="_blank" href="/download/' + self.value + '/' + self.path_key + '" >'+self.value+'</a>');
            }
        }
    },
    _finalizeView : function() {

    },
    upload : function () {
        var self = this;
        var body = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + 'upload_dialog_content_tpl');
        var modelName = self.modelName;
        var params = {
            path_key : self.path_key,
            type : self.uploadType,
            icon : "",
            filename : 'default.png',
        }
        log.info("action upload " + self.key + " type " + self.uploadType,params);
        $(body).find('[data-preview]').attr('data-template',self.idItemPreviewTemplate);
        $.renderTemplate('#'+body.attr('id'), '#'+body.attr('id'), params);

        var dialogId = self._getDialogId();

        $(dialogId + ' .modal-body').html(body.html());
        $(dialogId + ' .modal-title').html($.translate('general-add'));
        $(dialogId + ' [data-file-label]').html($.translate('general-accepted-extensions'));
        $(dialogId + ' [data-estensioni-label]').html(' ');

        body.remove();
        $(dialogId + ' .btok').addClass("disabled");

        $(dialogId + ' form').ajaxForm({
            beforeSubmit: function (a, f, o) {
                o.dataType = 'json';
                $.waitStart();
            },
            error: function (data, error, msg) {
                //alert("JSON error" + data + ' ' + error + ' ' + msg);
                $.waitEnd();
                //$.errorDialog("Upload error " + data + " " + error + " " + msg);
                self._showError("Upload error " + data + " " + error + " " + msg)
                $(dialogId + ' .btok').addClass("disabled");
            },
            success: function (data) {
                $.waitEnd();
                if (data.error) {
                    self._showError(data.msg);
                    $(dialogId + ' .btok').addClass("disabled");
                    return;
                }
                if (self.uploadType == 'foto') {
                    var image_src = Facade.getUrl('/imagecache/small/' + data.result.filename);
                    //$(dialogId + ' .preview').attr('src',image_src ).removeClass('hide');
                    $(dialogId + " [data-icon]").attr('src',image_src );
                }
                else {
                    //var icon_src = Facade.getUrl("/imagecache/icon/" + self.icons[data.result.ext]);
                    //$(dialogId + ' .preview').attr("src", icon_src).removeClass('hide');
                    $(dialogId + " [data-icon]").addClass(self.icons[data.result.ext]);
                }
                self.uploaded_json = data.result;
                console.log('uploaded recevied',data);
                $(dialogId + ' .btok').removeClass("disabled");
                self.afterUpload(data);
            }
        });
        // auto upload
        $(dialogId + ' input[name="file"]').autoUpload(function () {
            $(dialogId + ' form').submit();
        })

        $(dialogId).modal('show').ok(function () {
            self.ok();
        }).cancel(function () {
            self.cancel();
        })
    },
    ok : function () {
        var self  = this;
        self.value = self.uploaded_json.filename;
        self._renderTemplateData(self.container);

        //console.log($(self.container).find(self.control_selector),self.uploaded_json.filename);
        //$(self.container).find('[data-filename]').html(self.uploaded_json.filename);
        $(self.container).find(self.control_selector).attr('value',self.uploaded_json.filename);
        self._finalizeEdit();
    },
    cancel : function () {

    },
    /**
     * aggancia gli eventi sui pulsanti degli upload
     */
    _bindDeleteEvents : function () {
        var self = this;
        $(self.container).find('[data-button_delete]').unbind('click');
        $(self.container).find('[data-button_delete]').click(function () {
            var index = $(this).closest("[data-" + self.uploadType + "_item]").index();
            self.deleteItem(index);
        });
    },
    // addItem : function () {
    //     var self = this;
    //     log.info("action upload " + self.key + " type " + self.uploadType);
    //     var body = $.createDynamicContainer('#' + self.prefixTemplateClass + '_' + self.uploadType + '_dialog_upload_tpl');
    //     var modelName = self.modelName;
    //
    //     var params = {
    //         path_key: self.path_key,
    //         type : self.uploadType,
    //         langs : self.langs,
    //         type : self.key,
    //
    //     }
    //     log.info("action upload " + self.key + " type " + self.uploadType,params);
    //     $.renderTemplate('#'+body.attr('id'), '#'+body.attr('id'), params);
    //
    //     var dialogId = self._getDialogId();
    //     $(dialogId + ' .modal-body').html(body.html());
    //     body.remove();
    //     $(dialogId + ' .btok').addClass("disabled");
    //     $(dialogId + ' form').ajaxForm({
    //         beforeSubmit: function (a, f, o) {
    //             o.dataType = 'json';
    //             $.waitStart();
    //         },
    //         error: function (data, error, msg) {
    //             //alert("JSON error" + data + ' ' + error + ' ' + msg);
    //             $.waitEnd();
    //             //$.errorDialog("Upload error " + data + " " + error + " " + msg);
    //             self._showError("Upload error " + data + " " + error + " " + msg)
    //             $(dialogId + ' .btok').addClass("disabled");
    //         },
    //         success: function (data) {
    //             $.waitEnd();
    //             if (data.error) {
    //                 //$.errorDialog("Error: " + data.msg.toString());
    //                 self._showError(data.msg);
    //                 $(dialogId + ' .btok').addClass("disabled");
    //                 return;
    //             }
    //             if (self.uploadType == 'foto')
    //                 $(dialogId + ' .preview').attr('src','/imagecache/small/'+data.result.filename).removeClass('hide');
    //             else {
    //                 $(dialogId + ' .preview').attr("src", "/imagecache/icon/" +
    //                     ModelsConfs.icons[data.result.ext]).removeClass('hide');
    //             }
    //
    //             // aggiorno i campi di contorno di uploadfoto
    //             for (var k in data.result) {
    //                 $(dialogId + ' form').find('input[name="' + k + '"]').attr('value', data.result[k]);
    //             }
    //             // aggiorno il nome con il nome file se non valorizzato
    //             for (var i in self.langs) {
    //                 var lang = self.langs[i];
    //                 if (!$(dialogId + ' form').find('input[name="nome_' + lang + '"]').attr('value')) {
    //                     $(dialogId + ' form').find('input[name="nome_'+ lang+'"]').attr('value', data.result['original_name']);
    //                 }
    //             }
    //             /*
    //              if ($('#upload_foto_dialog form').find('input[name="nome"]').attr('value') == '') {
    //              $('#upload_foto_dialog form').find('input[name="nome"]').attr('value', data.result['original_name']);
    //              }
    //              */
    //             $(dialogId + ' .btok').removeClass("disabled");
    //             self.afterUpload(data);
    //         }
    //     });
    //     // auto upload
    //     $(dialogId + ' input[name="file"]').autoUpload(function () {
    //         $(dialogId + ' form').submit();
    //     })
    //
    //     $(dialogId).modal('show').ok(function () {
    //         var formData = $(dialogId + ' form').serializeAssoc();
    //         // self.viewObj.addFotoItem(formData,key);
    //         formData.updated_at  = new Date();
    //         self.renderNewItem(formData);
    //     }).cancel(function () {
    //         //alert('cancel');
    //     })
    // },

    // _getTemplate : function () {
    //     var self = this;
    //     var tplId = self.templateId;
    //     if (!tplId) {
    //         tplId = '#'+self.prefixTemplateClass+"_"+self.uploadType+"_"+self.mode+"_tpl";
    //         if ($(tplId).length == 0)
    //             tplId = '#'+self.prefixTemplateClass+"_"+self.type+"_tpl";
    //         if ($(tplId).length == 0)
    //             throw "Template source " + '#'+self.prefixTemplateClass+"_"+self.uploadType+"_"+self.mode+"_tpl Not found";
    //     }
    //
    //     return $.createDynamicContainer(tplId);
    // },

    _getDialogId : function () {
        var self = this;
        return '#default_upload_dialog';
    },
    _showError : function (msg) {
        var self = this;
        $(self._getDialogId() + ' .alert').removeClass('hide').html(msg)
    },
    /**
     * metodo chiamato dopo che il file e' stato uploadato
     * @param data: dati in json ritornati dal backend
     */
    afterUpload : function (data) {
    },

    _renderTemplateData : function (container) {
        var self = this;

        if (self.value) {
            if (self.uploadType == 'foto') {
                var tplData = {
                    link: '/viewimage/' + self.value + '/imagecache/' + self.imagecacheTemplate,
                    filename: '',
                    icon: '',
                    uploadType: self.uploadType,
                }
            } else {
                var tplData = {
                    link: self.value ? Facade.getUrl('/download/' + self.value) : '#',
                    filename: self.value,
                    icon: Utility.getMimetypeIcon(self.value),
                    uploadType: self.uploadType,
                }
            }
            $.renderTemplate(container, container, tplData);
        }


    }
});
